import hasPartnersDomainUpsell from './has-partners-domain-upsell';
import isDeveloperMode from './is-developer-mode';

export default {
  hasPartnersDomainUpsell,
  isDeveloperMode,
};
